import { render, staticRenderFns } from "./pondAdd copy.vue?vue&type=template&id=6adfd647&scoped=true&"
import script from "./pondAdd copy.vue?vue&type=script&lang=js&"
export * from "./pondAdd copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adfd647",
  null
  
)

export default component.exports